import { useTripsTripSubscriptionExpiringSoonCountRetrieveQuery } from 'src/common/external/bambi-api/tripsApi';
import { useUserRoles } from 'src/features/auth/useUserRoles';

export default function useTripSubscriptsExpiringSoonCount() {
  const { isRideOrderingPortalUser } = useUserRoles();
  const { data } = useTripsTripSubscriptionExpiringSoonCountRetrieveQuery(
    undefined,
    {
      skip: isRideOrderingPortalUser,
    }
  );

  return data?.count;
}
